import { render, staticRenderFns } from "./SPhone.vue?vue&type=template&id=1b56f40c"
import script from "./SPhone.vue?vue&type=script&lang=js"
export * from "./SPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports